import Cookies from 'js-cookie';
import React, { createContext, useState } from 'react';

const DEFAULT_STATE = {
  REQUIRED: false,
  FUNCTIONAL: false,
  ADVERTISING: false,
  accepted: false,
};

const COOKIE_KEY = 'accepted_cookies';

export const AcceptedCookiesContext = createContext({
  ...DEFAULT_STATE,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setAcceptedCookies: (_items: { [key: string]: boolean }) => {},
});

export const AcceptedCookies: React.FC = ({ children }) => {
  const [values, setValues] = useState<typeof DEFAULT_STATE>(() => {
    try {
      const cookiesRaw = Cookies.get(COOKIE_KEY);
      if (cookiesRaw) {
        return JSON.parse(cookiesRaw);
      } else {
        return DEFAULT_STATE;
      }
    } catch (err) {
      return DEFAULT_STATE;
    }
  });

  function setAcceptedCookies(items: { [key: string]: boolean }) {
    setValues((val) => {
      const values = { ...val, ...items, accepted: true };
      Cookies.set(COOKIE_KEY, JSON.stringify(values), { expires: 365 });
      return values;
    });
  }

  return (
    <AcceptedCookiesContext.Provider
      value={{
        ...values,
        setAcceptedCookies,
      }}
    >
      {children}
    </AcceptedCookiesContext.Provider>
  );
};
